import React, { useState, useEffect } from 'react'
import styles from './index.module.css'
import TermsContent from './TermsContent'
import PrivacyContent from './PrivacyContent'
import ReturnContent from './ReturnContent'

const MENU_ITEMS = [
  { id: 'terms-and-conditions', label: 'Terms & Conditions' },
  { id: 'privacy-policy', label: 'Privacy Policy' },
  { id: 'return-policy', label: 'Return & Refund Policy' },
]

const TermsCondition = () => {
  const [activeTab, setActiveTab] = useState('terms-and-conditions')

  useEffect(() => {
    const hash = window.location.hash
    if (hash) {
      setActiveTab(hash.split('#')[1])
    }
  }, [])

  return (
    <div className={styles.mainDiv}>
    <div className={styles.navBar}>
        <a href="/" className={styles.logoLink} aria-label="Go to home">
          <div className={styles.logo} />
        </a>
    </div>
      <div className={styles.innerDiv}>
        <div className={styles.twoCol}>
          <aside className={styles.leftContainer}>
            <nav className={styles.menu}>
              {MENU_ITEMS.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  className={`${styles.menuItem} ${activeTab === item.id ? styles.menuItemActive : ''}`}
                  onClick={() => {setActiveTab(item.id); window.location.hash = item.id}}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </aside>
          <main className={styles.rightContainer}>
            {activeTab === 'terms-and-conditions' && (
            <TermsContent activeTab={activeTab} />
          )}
          {activeTab === 'privacy-policy' && <PrivacyContent />}
          {activeTab === 'return-policy' && <ReturnContent />}
          </main>
        </div>
      </div>
    </div>
  )
}

export default TermsCondition
